import { render } from "./oaExamineAssCont.vue?vue&type=template&id=20a8376a&scoped=true"
import script from "./oaExamineAssCont.vue?vue&type=script&lang=js"
export * from "./oaExamineAssCont.vue?vue&type=script&lang=js"

import "./oaExamineAssCont.vue?vue&type=style&index=0&id=20a8376a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8376a"]])

export default __exports__